export class AccessToken {
  exp: number;
  scope: string[];

  constructor(token: AccessToken) {
    this.exp = token.exp;
    this.scope = token.scope;
  }
}
